<div class="d-flex justify-content-between unavailable-product align-items-center">
  <span class="product-name p-2">{{ product.name }}</span>
  <fa-icon [icon]="timesIcon" size="2x" class="set-available-button p-2" (click)="setProductAvailable()"></fa-icon>
</div>
